<template lang="pug">
  v-card.mt-5.full-width(width="100")
    Header(
      icon="plus",
      color="success",
      :to="{ name: 'createShop' }",
    )
       template(v-slot:filters="")
        v-col(fluid)
          v-spacer
        v-col(sm=4)
          div.action-wrapper
            FilterBox.mr-2(
              :label="$t('table.shop.filter')",
              :search.sync="search",
              @update:search="fetch({})",
            )
            v-btn.ml-1(
              fab,
              small,
              depressed,
              v-if="isSuperadmin",
              color="primary",
              @click="exportData",
            )
              v-icon fas fa-file-download
        
    TableWrapper(
      loading-text="Loading... Please wait",
      ref="table",
      type="shop",
      :items="items",
      :loading="isLoading",
      :misc="misc",
      @sort="fetch",
    )
      template(v-slot:default="{ item, headers, misc }")
        RowWrapper(
          :item="item",
          :headers="headers",
          :misc="misc",
          confirmation-key="name",
          type="shop",
          @deleted="fetch({})",
        )

</template>

<script>
import { mapGetters } from 'vuex';
import { mergeRight } from 'ramda';
import { progressWrapper, roleManager, tableHelper } from '@/config/mixins.js';

import FilterBox from '@/components/table/FilterBox.vue';
import Header from '@/components/forms/Header.vue';
import RowWrapper from '@/components/wrapper/RowWrapper.vue';
import TableWrapper from '@/components/wrapper/TableWrapper.vue';

export default {
  components: {
    FilterBox,
    Header,
    RowWrapper,
    TableWrapper,
  },

  mixins: [progressWrapper, roleManager, tableHelper],

  data() {
    return {
      search: null,
      misc: {
        sortBy: 'name',
        sortDesc: true,
      },
    };
  },

  computed: {
    ...mapGetters({
      items: 'shop/items',
    }),
  },

  methods: {
    prepareFetchPayload() {
      return {
        type: 'shop',
        params: {
          search: this.search,
          hardFetch: true,
        },
      };
    },

    exportData() {
      this.exportCSV({
        type: 'shop',
        fileName: 'shop.csv',
        params: mergeRight(this.$refs.table.misc, { search: this.search }),
      });
    },
  },
};
</script>
